<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" v-show="isEnabled"  />
      <feather-icon icon="CopyIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openDuplicateConfirm"  />
      <feather-icon icon="XIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openCancelApprobation" v-show="!isEnabled"   />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" v-show="isEnabled" />
    </div>
</template>

<script>
export default {
  name: 'ForecastActionsCellRenderer',
  computed: {
    isEnabled() {
      return this.params.data.approbationDate === null;
    }
  },
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
    },

    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('GradeControl.Forecast.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },

    openDuplicateConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('GradeControl.Forecast.ConfirmDuplicate'),
        accept: this.duplicateRecord
      });
    },

    duplicateRecord () {
      this.params.context.componentParent.duplicateData(this.params.data);
    },

    openCancelApprobation() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('GradeControl.Forecast.ConfirmCancelApprobation'),
        accept: this.cancelApprobation
      });
    },

    cancelApprobation () {
      this.params.context.componentParent.cancelApprobation(this.params.data);
    },

    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.data.locationForecastId);
    }
  }
}
</script>
